import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * Shared "Status + Confirmation #" two-column row used at the bottom of
 * AddSegmentDialog and EditSegmentDialog. Status changes also update
 * `board_list` so legacy filters stay in sync.
 *
 * Variants:
 *   - default: two-column Status + Confirmation #
 *   - hideStatus + showBookingRef: two-column Confirmation # + Booking Ref
 *     (used by EditPendingSegmentDialog where status doesn't apply)
 *   - hideStatus alone: single Confirmation # field
 */
export function SegmentStatusConfirmationFields({
  segment,
  onChange,
  testIdPrefix = "segment",
  hideStatus = false,
  showBookingRef = false,
}) {
  const ConfirmationInput = (
    <div className="grid gap-2">
      <Label htmlFor="confirmation">Confirmation #</Label>
      <Input
        id="confirmation"
        data-testid={`${testIdPrefix}-confirmation-input`}
        placeholder="ABC123"
        value={segment.confirmation_number || ""}
        onChange={(e) => onChange({ confirmation_number: e.target.value })}
      />
    </div>
  );

  if (hideStatus && showBookingRef) {
    return (
      <div className="grid grid-cols-2 gap-4">
        {ConfirmationInput}
        <div className="grid gap-2">
          <Label htmlFor="booking_ref">Booking Reference</Label>
          <Input
            id="booking_ref"
            data-testid={`${testIdPrefix}-booking-ref-input`}
            placeholder="Alternative reference"
            value={segment.booking_reference || ""}
            onChange={(e) => onChange({ booking_reference: e.target.value })}
          />
        </div>
      </div>
    );
  }

  if (hideStatus) {
    return ConfirmationInput;
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="grid gap-2">
        <Label htmlFor="status">Status</Label>
        <Select
          value={segment.status}
          onValueChange={(value) => onChange({ status: value, board_list: value })}
        >
          <SelectTrigger data-testid={`${testIdPrefix}-status-select`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent position="popper" className="z-[100]">
            <SelectItem value="planned">Planned</SelectItem>
            <SelectItem value="booked">Booked</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {ConfirmationInput}
    </div>
  );
}

export default SegmentStatusConfirmationFields;
